module.exports = "/images/pin-unknown.png?e615ee4992657ddc021f8adb4a4bb634";